import { FC } from 'react';
import arrowDownGray from 'images/arrow-down-gray.svg';

const ArrowDownGrayIcon: FC = () => {
  return <img src={arrowDownGray} alt="arrow-down-gray-icon" />;
};
export default ArrowDownGrayIcon;
